// store/forms/photosForm/photosFormState.js
// State for the reusable photos module - can be integrated into any form

export const photosUIInitialState = {
  // Upload state
  isUploading: false,
  uploadProgress: 0,
  uploadError: null,

  // Pending uploads (FormPhotos instances with local file data)
  selectedPhotos: [],

  // Delete confirmation modal
  showDeleteConfirm: false,
  photoToDelete: null,

  // Photo view/zoom modal
  viewModalOpen: false,
  viewingPhoto: null, // FormPhotos instance being viewed
};
